import React, { useState } from "react";
import EditGSTIN from "../SubComponents/ProfileSetup/SubComponents/EditGSTIN";
import { useDispatch } from "react-redux";
import { setUser as setUserReducer } from "../../../reducers/userReducer";
import EditTaxPercentage from "../SubComponents/ProfileSetup/SubComponents/EditTaxPercentage";
import EditCurrency from "../SubComponents/ProfileSetup/SubComponents/EditCurrency";
import EditTermsConditions from "../SubComponents/ProfileSetup/SubComponents/EditTermsConditions";

const InvoiceSettings = ({ dsp, user: initialUser, onUserUpdate }) => {
  const [isGstinEdit, setIsGstinEdit] = useState(false);
  const [user, setUser] = useState(initialUser);
  const [isEditTax, setIsEditTax] = useState(false);
  const [isEditcurrency, setIsEditCurrency] = useState(false);
  const [isEditTermsConditions, setIsEditTermsConditions] = useState(false);
  const settings = [
    {
      lable: "tax",
      title: "Tax Percentage (%)",
      desc: "Add your Tax %",
      // value:
      //   user?.dsp?.is_tax_applicable === false
      //     ? "Tax will not be applicable on my service"
      //     : user?.dsp?.tax
      //       ? `${user?.dsp?.tax}%`
      //       : null,
      value: (() => {
        const taxNum = Number(user?.dsp?.tax);

        // Sirf tab tax% dikhao jab tax > 0 ho
        if (taxNum > 0) return `${user?.dsp?.tax}%`;

        // "Not applicable" sirf tab dikhao jab is_tax_applicable explicitly false ho
        // AND tax bhi 0 ho - but GSTIN ya currency set ho (matlab user ne profile configure kiya hai)
        if (
          user?.dsp?.is_tax_applicable === false &&
          taxNum === 0 &&
          user?.dsp?.gstin
        )
          return "Tax will not be applicable on my service";

        return null;
      })(),
    },

    {
      lable: "gstin",
      title: "TAX ID",
      desc: "Add your GSTIN/VAT",
      value: user?.dsp?.gstin || null,
    },
    {
      lable: "currency",
      title: "Currency",
      desc: "Add your currency type",
      value: user?.dsp?.invoice_currency
        ? `${user?.dsp?.invoice_currency} (${new Intl.NumberFormat("en", { style: "currency", currency: user?.dsp?.invoice_currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(0).replace(/\d/g, "").trim()})`
        : null,
    },
    {
      lable: "terms",
      title: "Terms & Conditions",
      desc: "Add your Terms & Conditions",
      value: user?.dsp?.invoice_terms_and_conditions || null,
    },
  ];
  //    const user = useSelector((state) => state.user?.user);
  const dispatch = useDispatch();
  const handleAdd = (item) => {
    if (item.lable == "gstin") {
      setIsGstinEdit(true);
    }
    if (item.lable == "tax") {
      setIsEditTax(true);
    }
    if (item.lable == "currency") {
      setIsEditCurrency(true);
    }
    if (item.lable == "terms") {
      setIsEditTermsConditions(true);
    }
  };

  return (
    <div
      style={{
        background: "#fff",
        minHeight: "100vh",
        padding: "15px",
        // fontFamily: "Arial",
        fontWeight: "500",
        fontSize: " 20px",
      }}
    >
      <h1 style={{ fontWeight: "500", marginBottom: "20px" }}>
        Invoice Settings
      </h1>

      <div>
        {settings.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems:
                item.lable === "terms" && item.value ? "flex-start" : "center",
              padding: "18px 0px",
            }}
          >
            <div style={{ maxWidth: "80%" }}>
              <p style={{ margin: 0, fontSize: "15px", color: "#333" }}>
                {item.title}
                {item.lable !== "terms" && item.value && (
                  <span
                    style={{
                      color:
                        item.value ===
                        "Tax will not be applicable on my service"
                          ? "#9CA3AF"
                          : "#333",
                      fontSize: "13px",
                    }}
                  >
                    {" "}
                    - {item.value}
                  </span>
                )}
                {!item.value && (
                  <span style={{ color: "#888", fontSize: "13px" }}>
                    {" "}
                    - {item.desc}
                  </span>
                )}
              </p>
              {item.lable === "terms" && item.value && (
                <div
                  style={{
                    margin: "6px 0 0 0",
                    fontSize: "14.5px",
                    color: "#333",
                    lineHeight: "1.8",
                  }}
                >
                  {/* {item.value
                    .split(/(?=\d+\.)/)
                    .filter((point) => point.trim())
                    .map((point, i) => (
                      <p key={i} style={{ margin: "4px 0" }}>
                        {point.trim()}
                      </p>
                    ))} */}
                  {item.value
                    .split(/\n/)
                    .filter((point) => point.trim())
                    .map((point, i) => (
                      <p key={i} style={{ margin: "4px 0" }}>
                        {point.trim()}
                      </p>
                    ))}
                </div>
              )}
            </div>

            <button
              style={{
                background: "none",
                border: "none",
                color: "#2f6fed",
                fontWeight: "500",
                cursor: "pointer",
                fontSize: "15px",
                marginRight: "13px",
              }}
              onClick={() => handleAdd(item)}
            >
              {item.value ? "Edit" : "Add"}
            </button>
          </div>
        ))}
        <div>
          <div
            style={{
              // marginTop: "20px",
              fontSize: "14px",
              color: "black",
              lineHeight: "25px",
            }}
          ></div>
        </div>
        {isGstinEdit && (
          <EditGSTIN
            user={user}
            open={isGstinEdit}
            onClose={() => {
              setIsGstinEdit(false);
            }}
            onUserUpdate={(updatedUser) => {
              setUser(updatedUser);
              dispatch(setUserReducer(updatedUser));
              onUserUpdate?.(updatedUser);
              setIsGstinEdit(false);
            }}
          />
        )}
        {isEditTax && (
          <EditTaxPercentage
            dsp={user?.dsp}
            open={isEditTax}
            onClose={() => {
              setIsEditTax(false);
            }}
            onUserUpdate={(dsp) => {
              let updatedUser = { ...user, dsp: dsp };
              console.log("updatedUser", user);
              setUser(updatedUser);
              dispatch(setUserReducer(updatedUser));
              setIsEditTax(false);
            }}
          />
        )}
        {isEditcurrency && (
          <EditCurrency
            dsp={user?.dsp}
            open={isEditcurrency}
            onClose={() => {
              setIsEditCurrency(false);
            }}
            onUserUpdate={(dsp) => {
              let updatedUser = { ...user, dsp: dsp };
              console.log("updatedUser", user);
              setUser(updatedUser);
              dispatch(setUserReducer(updatedUser));
              setIsEditCurrency(false);
            }}
          />
        )}
        {isEditTermsConditions && (
          <EditTermsConditions
            dsp={user?.dsp}
            open={isEditTermsConditions}
            onClose={() => {
              setIsEditTermsConditions(false);
            }}
            onUserUpdate={(dsp) => {
              let updatedUser = { ...user, dsp: dsp };
              console.log("updatedUser", user);
              setUser(updatedUser);
              dispatch(setUserReducer(updatedUser));
              setIsEditCurrency(false);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default InvoiceSettings;
